
import { useState } from "react";

import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { DisenioLote } from "../../layout";
import { FormDistribucionPollos, TarjetasOpciones } from "../../components";
import { useLotesFuncion, useLoteXID } from "../../../hooks";
import { ModalFormUno } from "../../components/components/ModalFormUno";
import { useModalesStore } from "../../../store";





export const OpcionesLotes = () => {


    const { id } = useParams();
    // const { loteXIDQuery } = useLoteXID(`${id}`);
    // const loteInfo = loteXIDQuery?.data;
    const { handleEliminarInfo, handleNavegar } = useLotesFuncion();
    const { changeEstadoModalUno } = useModalesStore(); 
    const [genero, setGenero] = useState('');


    const handleAbrilModal = (url) => {
        setGenero(url);
        changeEstadoModalUno(true);
    }


    const data = [
        {key:1, titulo:'Editar Lote', function: handleNavegar, url:'edit', icono:'setting'},
        {key:2, titulo:'Información Lote', function: handleNavegar, url:'info', icono:'info'},
        {key:3, titulo:'Distribución General', function: handleNavegar, url:'distri', icono:'merge'},
        {key:4, titulo:`Generar Distribución`, function: handleAbrilModal, url:'HEMBRA', icono:'sexo'},
        // {key:4, titulo:`Generar Distribución ${loteInfo?.hembras}`, function: handleAbrilModal, url:'HEMBRA', icono:'sexo'},
        // {key:5, titulo:`Machos ${loteInfo?.machos}`, function: handleAbrilModal, url:'MACHO', icono:'sexo'},
        {key:6, titulo:'Eliminar Lote', function: handleEliminarInfo, url:'info', icono:'eliminar'},
    ];

    
    
    return (

        <DisenioLote titulo="Opciones de Lote" url={1}>
            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>


            <ModalFormUno titulo="Distribución de Pollo" valor={{}} onClose={() => changeEstadoModalUno(false)}>
                <FormDistribucionPollos sexo={genero} />
            </ModalFormUno>
        </DisenioLote>

    )
}
